export default __webpack_public_path__ + "static/media/FreeText_qr_icon.749743de.svg";